import React, { Component } from 'react';
import PropTypes from 'prop-types';

import parseJSON from 'common/util/parseJSON';
import SrPdfGeneratorRenterAppAdditionalQuestions from 'client/pages/SrPdfGenerator/PdfComponents/SrPdfGeneratorRenterAppAdditionalQuestions';

import { SCREEN_ID_PDF_GENERATOR } from 'client/constants/screenIds';

import log from 'client/lib/log';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withLocationQuery from 'client/helpers/withLocationQuery';

const getPdfComponentFromComponentId = (componentId) => {
  switch (componentId) {
    case 'renter-app-additional-questions': {
      return SrPdfGeneratorRenterAppAdditionalQuestions;
    }
    default: {
      const error = new Error(`Component ID ${componentId} not supported.`);
      error.name = 'SrPdfGeneratorComponentIdNotSupportedError';
      error.details = {
        componentId,
      };
      throw error;
    }
  }
};

@withScrollToTop
@withTransitionHook
@withLocationQuery
@withScreenId(SCREEN_ID_PDF_GENERATOR)
class SrPdfGenerator extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'PDF Generator | Sunroom Rentals',
  });

  render() {
    const { match, locationQuery } = this.props;

    const { pdfComponentId } = match.params;
    const PdfComponent = getPdfComponentFromComponentId(pdfComponentId);
    let values;

    try {
      values = parseJSON(global.atob(locationQuery.values));
    } catch (error) {
      log.warn(`Failed to parse values object: ${values}`);
    }

    return <PdfComponent {...(values || {})} />;
  }
}

SrPdfGenerator.propTypes = {
  match: PropTypes.object.isRequired,
};

SrPdfGenerator.displayName = 'SrPdfGenerator';

export default SrPdfGenerator;
